<template>
    <div class="bg-white shadow overflow-hidden sm:rounded-lg">
        <div class="px-4 py-5 sm:px-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">Seus Dados</h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">Informações pessoais e apólices (Somente Leitura).</p>
        </div>
        <div class="border-t border-gray-200" v-if="!loading && segurado">
            <dl>
                <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-medium text-gray-500">Nome Completo</dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{ segurado.nome }}</dd>
                </div>
                <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-medium text-gray-500">E-mail</dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">{{ segurado.email }}</dd>
                </div>
                <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-sm font-medium text-gray-500">Apólices Ativas</dt>
                    <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <ul role="list" class="border border-gray-200 rounded-md divide-y divide-gray-200">
                            <li v-for="apolice in segurado.apolices" :key="apolice.id" class="px-4 py-4 sm:px-6 hover:bg-gray-50 flex flex-col gap-3">
                                <div class="flex items-center justify-between">
                                    <p class="text-sm font-medium text-indigo-600 truncate">
                                        Número: {{ apolice.apolice?.numero || 'Sem número' }} | Cia: {{ apolice.apolice?.seguradora?.nome || '-' }}
                                    </p>
                                    <div class="ml-2 flex-shrink-0 flex">
                                        <p class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" 
                                           :class="apolice.status_vinculo === 'ativo' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                                            {{ apolice.status_vinculo.toUpperCase() }}
                                        </p>
                                    </div>
                                </div>
                                <div class="mt-2 sm:flex sm:justify-between w-full">
                                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
                                        <p class="text-sm text-gray-500">
                                            <span class="font-semibold">Inclusão:</span> {{ formatarData(apolice.data_inclusao) }}
                                        </p>
                                        <p class="text-sm text-gray-500">
                                            <span class="font-semibold">Últ. IPCA:</span> {{ formatarData(apolice.data_ultimo_ipca) }}
                                        </p>
                                        <p class="text-sm text-gray-500">
                                            <span class="font-semibold">Últ. Reenquadr.:</span> {{ formatarData(apolice.data_ultimo_reenquadramento) }}
                                        </p>
                                        <p class="text-sm text-gray-500">
                                            <span class="font-semibold">Capital Atual:</span> {{ formatarMoeda(apolice.capital_atual) }}
                                        </p>
                                        <p class="text-sm text-gray-500">
                                            <span class="font-semibold">Prêmio:</span> {{ formatarMoeda(apolice.valor_premio) }}
                                        </p>
                                        <p class="text-sm text-gray-500">
                                            <span class="font-semibold">Decesso:</span> {{ formatarMoeda(apolice.valor_decesso) }}
                                        </p>
                                        <p v-if="apolice.data_cancelamento" class="text-sm text-red-500 sm:col-span-2 lg:col-span-3">
                                            <span class="font-semibold">Cancelada em:</span> {{ formatarData(apolice.data_cancelamento) }}
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li v-if="(!segurado.apolices || segurado.apolices.length === 0)" class="pl-3 pr-4 py-3 flex items-center text-sm text-gray-500">
                                Nenhuma apólice encontrada.
                            </li>
                        </ul>
                    </dd>
                </div>
            </dl>
        </div>
        <div v-if="loading" class="p-6 text-center text-gray-500">Carregando informações...</div>
    </div>
</template>

<script>
import ClientLoginRepository from '@/services/ClientLoginRepository.vue';

export default {
    name: 'ClientePerfilView',
    data() {
        return {
            loading: true,
            user: null,
            segurado: null,
            service: new ClientLoginRepository()
        }
    },
    async mounted() {
        await this.carregarDados();
    },
    methods: {
        async carregarDados() {
            this.loading = true;
            try {
                const clientUser = JSON.parse(window.localStorage.getItem('myClientUser') || '{}');
                const res = await this.service.getMe(clientUser.token);
                this.user = res.data.user;
                this.segurado = res.data.segurado;
            } catch (error) {
                console.error("Erro ao puxar dados", error);
            } finally {
                this.loading = false;
            }
        },
        formatarData(dataISO) {
            if (!dataISO) return '-';
            // Corrige o timezone do ISO adicionando a string local se for timestamp de DB
            const d = new Date(dataISO);
            return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
        },
        formatarMoeda(valor) {
            if (!valor) return 'R$ 0,00';
            return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    }
}
</script>
